export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/74cc88c7571ddfe8037db442e45677ad.svg";